/* ── ColorPicker ── */

.picker {
  display: flex;
  flex-direction: column;
  gap: var(--nexus-space-sm);
}

.label {
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-sm);
  font-weight: 500;
  color: var(--nexus-text);
}

/* ── Controls row ── */

.controls {
  display: flex;
  align-items: center;
  gap: var(--nexus-space-sm);
}

/* ── Color swatch button ── */

.swatchButton {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: var(--nexus-radius-sm);
  border: 2px solid var(--nexus-border);
  cursor: pointer;
  flex-shrink: 0;
  overflow: hidden;
  transition:
    border-color var(--nexus-transition-normal),
    box-shadow var(--nexus-transition-normal);
}

.swatchButton:hover {
  border-color: var(--nexus-border-strong);
  box-shadow: 0 0 8px -2px rgba(178, 75, 243, 0.3);
}

.swatchButton:focus-visible {
  border-color: var(--nexus-border-focus);
  box-shadow: 0 0 0 2px rgba(178, 75, 243, 0.3);
  outline: none;
}

/* Hidden native input overlaid */
.nativeInput {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
}

/* ── Hex text input ── */

.hexInput {
  flex: 1;
  max-width: 120px;
  height: 40px;
  padding: 0 var(--nexus-space-sm);
  border: 1px solid var(--nexus-border);
  border-radius: var(--nexus-radius-sm);
  background: var(--nexus-surface);
  color: var(--nexus-text);
  font-family: var(--nexus-font-mono);
  font-size: var(--nexus-text-sm);
  outline: none;
  transition:
    border-color var(--nexus-transition-normal),
    box-shadow var(--nexus-transition-normal);
}

.hexInput:focus {
  border-color: var(--nexus-border-focus);
  box-shadow: 0 0 0 2px rgba(178, 75, 243, 0.15);
}

.hexInput::placeholder {
  color: var(--nexus-text-muted);
}

/* ── Preset swatches ── */

.presets {
  display: flex;
  flex-wrap: wrap;
  gap: var(--nexus-space-xs);
}

.preset {
  width: 28px;
  height: 28px;
  border-radius: var(--nexus-radius-sm);
  border: 2px solid transparent;
  cursor: pointer;
  transition:
    border-color var(--nexus-transition-fast),
    transform var(--nexus-transition-fast),
    box-shadow var(--nexus-transition-fast);
}

.preset:hover {
  transform: scale(1.15);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.preset:focus-visible {
  outline: 2px solid var(--nexus-border-focus);
  outline-offset: 2px;
}

.presetActive {
  border-color: #fff;
  box-shadow:
    0 0 0 2px var(--nexus-purple),
    0 2px 8px rgba(178, 75, 243, 0.3);
  transform: scale(1.1);
}

/* ── Mobile ── */

@media (max-width: 768px) {
  .hexInput {
    max-width: none;
  }
}
